import { paymentConstants, globalConstants } from "../../constants";

const initialState = {
  CheckoutID: null,
  paymentHistory: {},
  paymentHistoryFreelancer: {},
  paymentHistoryStats: {},
  adminPaymentHistory: {},
  savedPaymentCards: null,
  checkoutIdSavedCard: null,
};

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case paymentConstants.CHECKOUT_ID + globalConstants.SUCCESS:
      return {
        ...state,
        CheckoutID: action.data,
      };
    case paymentConstants.CHECKOUT_ID_SAVED_CARD + globalConstants.SUCCESS:
      return {
        ...state,
        checkoutIdSavedCard: action.data,
      };
    case paymentConstants.CHECKOUT_ID_NULL + globalConstants.SUCCESS:
      return {
        ...state,
        CheckoutID: null,
        checkoutIdSavedCard: null,
      };
    case paymentConstants.PAYMENT_HISTORY + globalConstants.SUCCESS:
      return {
        ...state,
        paymentHistory: action.data,
      };
    case paymentConstants.PAYMENT_HISTORY_FREELANCER + globalConstants.SUCCESS:
      return {
        ...state,
        paymentHistoryFreelancer: action.data,
      };
    case paymentConstants.PAYMENT_HISTORY_STATS + globalConstants.SUCCESS:
      return {
        ...state,
        paymentHistoryStats: action.data,
      };
    case paymentConstants.ADMIN_PAYMENT_HISTORY + globalConstants.SUCCESS:
      return {
        ...state,
        adminPaymentHistory: action.data,
      };
    case paymentConstants.SAVED_PAYMENT_CARDS + globalConstants.SUCCESS:
      return {
        ...state,
        savedPaymentCards: action.data,
      };
    default:
      return state;
  }
};

export default PaymentReducer;
